export const formatPhoneNumber = (phone: string): string => {
  // Format: +33 7 32022233 -> +33 7 32 02 22 33
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.startsWith('33') && cleaned.length === 11) {
    return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 3)} ${cleaned.slice(3, 5)} ${cleaned.slice(5, 7)} ${cleaned.slice(7, 9)} ${cleaned.slice(9, 11)}`
  }
  return `+${phone}`
}
